import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import axios from 'axios';

import './App.css';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      failure: false,
      fetching: false,
      index: 0,
      reps: [],
      success: false,
      zip: null,
      messages: null
    };

    this.storageRef = this.props.firebase.storage().ref();
  }

  componentDidMount() {
    this.startDatabaseQueries();
  }

  startDatabaseQueries = () => {
    var appId = this.props.children.props.params.appId;
    this.props.firebase.database().ref(appId).once('value').then((snapshot) => { this.setState({ messages: snapshot.val() });
    });
  }


  fetchWithZip = (zip) => {
    const url = `https://congress.api.sunlightfoundation.com/legislators/locate?zip=${zip}&cb=${Math.random().toString(36).slice(2)}`;
    const appId = this.props.children.props.params.appId;
    this.serverRequest = axios.get(url)
      .then((result) => {
        this.setState({
          index: 0,
          reps: result.data.results,
          fetching: false,
          success: true
        });

        if (window.location.pathname !== `/${appId}/results/${zip}`) {
          browserHistory.push(`/${appId}/results/${zip}`);
        }
      });

    this.setState({zip, fetching: true});
  }

  setIndex = (index) => {
    this.setState({ index });
  }

  componentWillUnmount = () => {
    if (this.serverRequest) {
      this.serverRequest.abort();
    }
  }

  render() {
    return (
      <div className="App">
        {React.cloneElement(this.props.children, {
          fetchWithZip: this.fetchWithZip,
          setIndex: this.setIndex,
          ...this.state })}
      </div>
    );
  }
}

export default App;




// WEBPACK FOOTER //
// ./src/App.js